import script from "./PreSportsCompetition.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsCompetition.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsCompetition.vue?vue&type=style&index=0&id=1b35501c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b35501c"]])

export default __exports__